"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateMetaManifest = exports.migrators = void 0;
/* eslint-disable */
/**
 * This file was automatically generated by scripts/manifest/migrate-ts.mustache.
 * DO NOT MODIFY IT BY HAND. Instead, modify scripts/manifest/migrate-ts.mustache,
 * and run node ./scripts/manifest/generateFormatTypes.js to regenerate this file.
 */
var _1 = require(".");
var tracing_js_1 = require("@web3api/tracing-js");
exports.migrators = {};
exports.migrateMetaManifest = tracing_js_1.Tracer.traceFunc("core: migrateMetaManifest", function (manifest, to) {
    var from = manifest.format;
    if (from === _1.latestMetaManifestFormat) {
        return manifest;
    }
    if (!(from in _1.MetaManifestFormats)) {
        throw new Error("Unrecognized MetaManifestFormat \"" + manifest.format + "\"");
    }
    throw new Error("This should never happen, MetaManifest migrators is empty. from: " + from + ", to: " + to);
});
//# sourceMappingURL=migrate.js.map